/**
 * 랜딩 A/B 판을 활동 기록 맥락에 싣는다 — 쿠키 `cm_lp` 가 살아 있는 동안 이 브라우저의 모든 이벤트(가입 · 로그인 뒤 서비스 화면 포함)가
 * `experiment_id`(`landing-v2`) · `variant`(`a` | `b`)를 갖는다. 쿠키가 없거나 지워졌으면 둘 다 `null` 로 돌린다.
 * 판 나누기 · 쿠키 쓰기는 middleware(`utils/experiment/landing-ab`)가 한다 — 여기는 읽기만 한다.
 * 🔑 `/?lp=a` · `/?lp=b` 로 판을 골라 보는 동안은 둘 다 `null` 이다 — 배정과 다른 판을 본 방문이 실험에 섞이지 않는다.
 */

import { readLandingPreview, readLandingVariant, LANDING_EXPERIMENT_ID } from 'src/utils/experiment/landing-ab';

import { setAnalyticsContext } from './client';

// ----------------------------------------------------------------------

/**
 * @param cookieHeader 쿠키 줄 — 기본은 `document.cookie`(브라우저 밖이면 아무것도 하지 않는다)
 * @param location 지금 주소 — 기본은 `window.location`
 * @returns 실은 판(없으면 `null`)
 */
export function applyLandingExperiment(
  cookieHeader?: string,
  location?: { pathname: string; search: string }
): 'a' | 'b' | null {
  const source = cookieHeader ?? (typeof document !== 'undefined' ? document.cookie : null);
  if (source === null) return null;
  const where = location ?? (typeof window !== 'undefined' ? window.location : null);
  const previewing = where ? readLandingPreview(where.pathname, where.search) : null;
  const variant = previewing ? null : readLandingVariant(source);
  setAnalyticsContext(variant ? { experimentId: LANDING_EXPERIMENT_ID, variant } : { experimentId: null, variant: null });
  return variant;
}
